(() => {
  // Handling time: 3-5 days (Standard worldwide)
  const HANDLING_DAYS = { min: 3, max: 5 };

  // Shipping transit times from Wanderprints shippingLanes (in days):
  const SHIPPING_TRANSIT_LANES = {
    US: [6, 10],
    CA: [6, 10],
    GB: [6, 10],
    FR: [6, 10],
    ES: [6, 10],
    NL: [6, 10],
    DE: [7, 11],
    IT: [7, 11],
    IE: [7, 11],
    AU: [8, 13],
    NZ: [8, 13],
    DEFAULT: [8, 14], // Applies to all other countries: DZ, VN, etc.
  };

  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const fmtDate = (d) => `${MONTHS[d.getMonth()]} ${d.getDate()}`;

  const fmtRange = (a, b) => {
    if (a.toDateString() === b.toDateString()) return fmtDate(a);
    if (a.getMonth() === b.getMonth()) {
      return `${MONTHS[a.getMonth()]} ${a.getDate()} – ${b.getDate()}`;
    }
    return `${fmtDate(a)} – ${fmtDate(b)}`;
  };

  const addDays = (baseDate, days) => {
    const date = new Date(baseDate);
    date.setDate(date.getDate() + days);
    return date;
  };

  const getShippingTransit = (countryCode) => {
    const code = (countryCode || '').trim().toUpperCase();
    return SHIPPING_TRANSIT_LANES[code] || SHIPPING_TRANSIT_LANES.DEFAULT;
  };

  const countryCodeToFlagUrl = (countryCode) => {
    const normalizedCode = (countryCode || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(normalizedCode)) return '';
    return `https://flagcdn.com/w40/${normalizedCode.toLowerCase()}.png`;
  };

  const calculateDates = (countryCode) => {
    const today = new Date();
    const [transitMin, transitMax] = getShippingTransit(countryCode);

    const placedDate = today;
    const shipStartDate = addDays(today, HANDLING_DAYS.min);
    const shipEndDate = addDays(today, HANDLING_DAYS.max);
    const deliverStartDate = addDays(today, HANDLING_DAYS.min + transitMin);
    const deliverEndDate = addDays(today, HANDLING_DAYS.max + transitMax);

    return {
      placedLabel: fmtDate(placedDate),
      shipLabel: fmtRange(shipStartDate, shipEndDate),
      deliverLabel: fmtRange(deliverStartDate, deliverEndDate),
      transitLabel: `${transitMin}–${transitMax} business days`,
    };
  };

  const renderEstimate = (element) => {
    const countryCode = element.dataset.countryCode || '';
    const flag = element.querySelector('[data-delivery-country-flag]');
    const target = element.querySelector('[data-delivery-date]');
    
    if (flag) {
      const flagUrl = countryCodeToFlagUrl(countryCode);
      flag.hidden = !flagUrl;
      if (flagUrl) flag.src = flagUrl;
    }

    const { placedLabel, shipLabel, deliverLabel, transitLabel } = calculateDates(countryCode);

    if (target) {
      target.textContent = deliverLabel;
    }

    // Update all timeline instances (both desktop popup and mobile modal)
    document.querySelectorAll('[data-timeline-date-placed]').forEach((el) => {
      el.textContent = placedLabel;
    });
    document.querySelectorAll('[data-timeline-date-shipped]').forEach((el) => {
      el.textContent = shipLabel;
    });
    document.querySelectorAll('[data-timeline-date-delivered]').forEach((el) => {
      el.textContent = deliverLabel;
    });

    // Update product policy accordion dynamic shipping details
    document.querySelectorAll('[data-policy-delivery-transit]').forEach((el) => {
      el.textContent = transitLabel;
    });
    document.querySelectorAll('[data-policy-delivery-date]').forEach((el) => {
      el.textContent = deliverLabel;
    });

    const countryNameEl = element.querySelector('[data-delivery-country-name]');
    if (countryNameEl && countryNameEl.textContent.trim()) {
      document.querySelectorAll('[data-policy-country-name]').forEach((el) => {
        el.textContent = countryNameEl.textContent.trim();
      });
    }
  };

  const openCountryModal = (modal) => {
    const deliveryInfo = document.querySelector('[data-delivery-estimate]');
    const select = modal.querySelector('select');
    const search = modal.querySelector('[data-delivery-country-search]');
    if (deliveryInfo && select) select.value = deliveryInfo.dataset.countryCode || select.value;
    if (search) {
      search.value = '';
      modal.querySelectorAll('option').forEach((option) => {
        option.hidden = false;
      });
    }
    modal.hidden = false;
    document.body.classList.add('delivery-country-modal-open');
    search?.focus();
  };

  const closeCountryModal = (modal) => {
    modal.hidden = true;
    document.body.classList.remove('delivery-country-modal-open');
  };

  const openTimelineModal = (modal) => {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('delivery-timeline-modal-open');
  };

  const closeTimelineModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('delivery-timeline-modal-open');
  };

  const setTimelinePopupOpen = (popup, isOpen) => {
    if (!popup) return;
    if (isOpen) {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    } else {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }
  };

  const init = () => {
    // Teleport modals to <body> so they escape container transforms and cover full viewport
    document.querySelectorAll('[data-delivery-timeline-modal]').forEach((modal) => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
    document.querySelectorAll('[data-delivery-country-modal]').forEach((modal) => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });

    document.querySelectorAll('[data-delivery-estimate]').forEach(renderEstimate);

    // Country selection modal handling
    document.querySelectorAll('[data-delivery-country-modal]').forEach((modal) => {
      const select = modal.querySelector('select');
      const search = modal.querySelector('[data-delivery-country-search]');

      search?.addEventListener('input', () => {
        const query = search.value.trim().toLocaleLowerCase();
        modal.querySelectorAll('option').forEach((option) => {
          const countryName = (option.dataset.countryName || option.textContent || '').trim().toLocaleLowerCase();
          option.hidden = Boolean(query) && !countryName.includes(query);
        });
      });

      modal.querySelectorAll('[data-delivery-country-close]').forEach((button) => {
        button.addEventListener('click', () => closeCountryModal(modal));
      });

      modal.querySelector('[data-delivery-country-apply]')?.addEventListener('click', () => {
        const deliveryInfo = document.querySelector('[data-delivery-estimate]');
        const option = select?.selectedOptions[0];
        if (!deliveryInfo || !select || !option) return;

        deliveryInfo.dataset.countryCode = select.value;
        const countryName = deliveryInfo.querySelector('[data-delivery-country-name]');
        if (countryName) countryName.textContent = option.dataset.countryName || option.textContent.trim();
        renderEstimate(deliveryInfo);
        closeCountryModal(modal);
      });
    });

    document.querySelectorAll('[data-delivery-country-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const modal = document.querySelector('[data-delivery-country-modal]');
        if (modal) openCountryModal(modal);
      });
    });

    // Timeline modal & popup handling
    const timelineModal = document.querySelector('[data-delivery-timeline-modal]');
    const timelinePopup = document.querySelector('[data-delivery-timeline-popup]');
    const timelineTrigger = document.querySelector('[data-delivery-timeline-open]');

    let hoverTimeout = null;

    if (timelineTrigger) {
      // Hover for desktop
      timelineTrigger.addEventListener('mouseenter', () => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        clearTimeout(hoverTimeout);
        setTimelinePopupOpen(timelinePopup, true);
      });

      timelineTrigger.addEventListener('mouseleave', () => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          setTimelinePopupOpen(timelinePopup, false);
        }, 180);
      });

      // Click: on mobile opens modal, on desktop toggles popup
      timelineTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.matchMedia('(max-width: 749px)').matches) {
          openTimelineModal(timelineModal);
        } else {
          const isCurrentlyOpen = timelinePopup?.classList.contains('is-open');
          setTimelinePopupOpen(timelinePopup, !isCurrentlyOpen);
        }
      });
    }

    if (timelinePopup) {
      timelinePopup.addEventListener('mouseenter', () => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        clearTimeout(hoverTimeout);
        setTimelinePopupOpen(timelinePopup, true);
      });

      timelinePopup.addEventListener('mouseleave', () => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          setTimelinePopupOpen(timelinePopup, false);
        }, 180);
      });

      // Prevent clicks inside popup from bubbling to document click-to-close
      timelinePopup.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    // Mobile modal close buttons
    if (timelineModal) {
      timelineModal.querySelectorAll('[data-delivery-timeline-close]').forEach((btn) => {
        btn.addEventListener('click', () => closeTimelineModal(timelineModal));
      });
    }

    // Document click to close desktop popup
    document.addEventListener('click', (event) => {
      if (timelinePopup?.classList.contains('is-open')) {
        if (!timelineTrigger?.contains(event.target) && !timelinePopup?.contains(event.target)) {
          setTimelinePopupOpen(timelinePopup, false);
        }
      }
    });

    // Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-delivery-country-modal]:not([hidden])').forEach(closeCountryModal);
      if (timelineModal && !timelineModal.hidden) {
        closeTimelineModal(timelineModal);
      }
      setTimelinePopupOpen(timelinePopup, false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
